module.exports = __webpack_public_path__ + "img/docx.bf6f8a2c.svg";